module.exports = __webpack_public_path__ + "static/media/emj20.51e15840.svg";